import Swal from "sweetalert2";

export const alertSuccess = (message = "Operation completed successfully") => {
  Swal.fire({
    icon: "success",
    title: message,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
  });
};

export const alertError = (message = "Something went wrong") => {
  Swal.fire({
    icon: "error",
    title: "Error",
    text: message,
    confirmButtonColor: "#dc2626",
  });
};

export const alertValidation = (errors) => {
  let errorList = "";

  Object.keys(errors).forEach((key) => {
    errors[key].forEach((err) => {
      errorList += `<div style="text-align:left">• ${err}</div>`;
    });
  });

  Swal.fire({
    icon: "warning",
    title: "Validation Error",
    html: errorList,
    confirmButtonColor: "#f59e0b",
  });
};

export const alertConfirm = async (title = "Are you sure?") => {
  return Swal.fire({
    title,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#2563eb",
    cancelButtonColor: "#dc2626",
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
  });
};
